module.exports = __webpack_public_path__ + "img/in-progress-application.46898c69.svg";